export const SET_MODULE_CONFIG = 'SET_MODULE_CONFIG'
